export default __webpack_public_path__ + "static/media/menu.010779db.svg";